// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.mapinfotooltip {
    position: absolute;
    z-index: 2;
    pointer-events: none;
}

div.mapinfotooltip-window {
    margin-top: 1em;
    background: var(--container-bg-color);
    box-shadow: 0px 0px 5px rgba(136, 136, 136, 1);
    border-radius: 0.5em;
    transform: translate(-50%, 0);
    -webkit-font-smoothing: antialiased;
    white-space: nowrap;
    pointer-events: all;
}

div.mapinfotooltip-titlebar {
    background-color: var(--titlebar-bg-color);
    color: var(--titlebar-text-color);
    font-weight: bold;
    padding: 0.25em 0.5em;
    border-radius: 0.5em 0.5em 0 0;
    display: flex;
    align-items: center;
    font-size: 90%;
}

span.mapinfotooltip-title {
    flex: 1 1 auto;
}

button.mapinfotooltip-button {
    flex: 0 0 auto;
    margin-right: 0.5em;
    border: none;
    background-color: transparent;
    background-color: var(--titlebar-bg-color);
    color: var(--titlebar-text-color);
}

button.mapinfotooltip-button:hover {
    color: var(--titlebar-bg-color);
    background-color: var(--titlebar-text-color);
}

div.mapinfotooltip-body {
    padding: 0.5em;
    font-size: 75%;
}

div.mapinfotooltip-body:after {
    content: '';
    display: block;
    position: absolute;
    left: calc(50% - 1em);
    top: -1em;
    width: 0;
    height: 0;
    border-left: 1em solid transparent;
    border-right: 1em solid transparent;
    border-bottom: 1em solid var(--titlebar-bg-color);
}

div.mapinfotooltip-body td {
    padding: 0.25em;
}

table.mapinfotooltip-body-routing td:last-child {
    display: flex;
}

table.mapinfotooltip-body-routing td:last-child button {
    flex: 1 1 auto;
}

td.mapinfotooltip-highligted {
    color: yellow;
    background-color: blue;
}`, "",{"version":3,"sources":["webpack://./qwc2/plugins/style/MapInfoTooltip.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,8CAA8C;IAC9C,oBAAoB;IACpB,6BAA6B;IAC7B,mCAAmC;IACnC,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,iCAAiC;IACjC,iBAAiB;IACjB,qBAAqB;IACrB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,0CAA0C;IAC1C,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;IAC/B,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,iDAAiD;AACrD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B","sourcesContent":["div.mapinfotooltip {\n    position: absolute;\n    z-index: 2;\n    pointer-events: none;\n}\n\ndiv.mapinfotooltip-window {\n    margin-top: 1em;\n    background: var(--container-bg-color);\n    box-shadow: 0px 0px 5px rgba(136, 136, 136, 1);\n    border-radius: 0.5em;\n    transform: translate(-50%, 0);\n    -webkit-font-smoothing: antialiased;\n    white-space: nowrap;\n    pointer-events: all;\n}\n\ndiv.mapinfotooltip-titlebar {\n    background-color: var(--titlebar-bg-color);\n    color: var(--titlebar-text-color);\n    font-weight: bold;\n    padding: 0.25em 0.5em;\n    border-radius: 0.5em 0.5em 0 0;\n    display: flex;\n    align-items: center;\n    font-size: 90%;\n}\n\nspan.mapinfotooltip-title {\n    flex: 1 1 auto;\n}\n\nbutton.mapinfotooltip-button {\n    flex: 0 0 auto;\n    margin-right: 0.5em;\n    border: none;\n    background-color: transparent;\n    background-color: var(--titlebar-bg-color);\n    color: var(--titlebar-text-color);\n}\n\nbutton.mapinfotooltip-button:hover {\n    color: var(--titlebar-bg-color);\n    background-color: var(--titlebar-text-color);\n}\n\ndiv.mapinfotooltip-body {\n    padding: 0.5em;\n    font-size: 75%;\n}\n\ndiv.mapinfotooltip-body:after {\n    content: '';\n    display: block;\n    position: absolute;\n    left: calc(50% - 1em);\n    top: -1em;\n    width: 0;\n    height: 0;\n    border-left: 1em solid transparent;\n    border-right: 1em solid transparent;\n    border-bottom: 1em solid var(--titlebar-bg-color);\n}\n\ndiv.mapinfotooltip-body td {\n    padding: 0.25em;\n}\n\ntable.mapinfotooltip-body-routing td:last-child {\n    display: flex;\n}\n\ntable.mapinfotooltip-body-routing td:last-child button {\n    flex: 1 1 auto;\n}\n\ntd.mapinfotooltip-highligted {\n    color: yellow;\n    background-color: blue;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
